module.exports = __webpack_public_path__ + "static/media/rocketfuel-circular.65a9b038.png";